import {useEffect,useRef} from "react";

export function useLiveRefresh(refresh:()=>void|Promise<void>,key="default",intervalMs=5000){
  const refreshRef=useRef(refresh);
  refreshRef.current=refresh;

  useEffect(()=>{
    let running=false,stopped=false;
    const run=async()=>{
      if(running||stopped||document.visibilityState==="hidden")return;
      running=true;
      try{await refreshRef.current()}finally{running=false}
    };
    const onFocus=()=>void run();
    const onVisibilityChange=()=>{if(document.visibilityState==="visible")void run()};
    void run();
    const timer=window.setInterval(()=>void run(),intervalMs);
    window.addEventListener("focus",onFocus);
    document.addEventListener("visibilitychange",onVisibilityChange);
    return()=>{
      stopped=true;
      window.clearInterval(timer);
      window.removeEventListener("focus",onFocus);
      document.removeEventListener("visibilitychange",onVisibilityChange);
    };
  },[key,intervalMs]);
}
